var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4857 17.7881C17.0606 11.7319 14.2299 10.1357 14.2299 7.11524V3.55761H14.8228C14.9801 3.55761 15.1309 3.49514 15.2421 3.38394C15.3533 3.27274 15.4157 3.12193 15.4157 2.96467V1.77879C15.4157 1.62153 15.3533 1.47072 15.2421 1.35952C15.1309 1.24832 14.9801 1.18585 14.8228 1.18585H8.89342C8.73616 1.18585 8.58534 1.24832 8.47415 1.35952C8.36295 1.47072 8.30048 1.62153 8.30048 1.77879V2.96467C8.30048 3.12193 8.36295 3.27274 8.47415 3.38394C8.58534 3.49514 8.73616 3.55761 8.89342 3.55761H9.48636V7.11524C9.48636 10.1357 6.65567 11.7319 4.23055 17.7881C3.45854 19.7152 1.47575 22.5317 11.8581 22.5317C22.2405 22.5317 20.2577 19.7152 19.4857 17.7881ZM17.5681 19.8646C16.7356 20.1136 15.079 20.3971 11.8581 20.3971C8.63727 20.3971 6.9806 20.1136 6.14811 19.8646C5.85283 19.7769 5.7378 19.4341 5.84215 19.1199C6.10305 18.3253 6.59519 16.9521 7.51543 15.4188C9.76385 11.6726 12.0965 16.0081 14.0378 16.0081C15.979 16.0081 15.4466 14.157 16.2008 15.4188C16.8949 16.5862 17.4561 17.8276 17.8741 19.1199C17.9784 19.4341 17.8634 19.7757 17.5681 19.8646Z",
    fill: "#5C5CAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.bb304a0a98458e7902a31ecf4f779fc7.svg";
export { ForwardRef as ReactComponent };